export enum BuilderAge {
  YOUTHFUL = -2,
  JUVENILE = -3,
}
